module.exports = __webpack_public_path__ + "fonts/GothamSSm-Book_Web.299e9ca.woff2";